import { render, staticRenderFns } from "./appendixPage1.vue?vue&type=template&id=97162c80&scoped=true"
import script from "./appendixPage1.vue?vue&type=script&lang=js"
export * from "./appendixPage1.vue?vue&type=script&lang=js"
import style0 from "./appendixPage1.vue?vue&type=style&index=0&id=97162c80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97162c80",
  null
  
)

export default component.exports